export default __webpack_public_path__ + "static/media/ser2.bad26a3c.svg";